var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../utils/dateUtils", "./reportBase"], function (require, exports, $, ko, log, urls_1, tools, DateUtils, ReportBase) {
    "use strict";
    var geometry = kendo.dataviz.geometry;
    var drawing = kendo.dataviz.drawing;
    var ActivityDashboard = /** @class */ (function (_super) {
        __extends(ActivityDashboard, _super);
        function ActivityDashboard() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.grandTotalsData = ko.observable({
                IsLocal: 0,
                IsIncoming: 0,
                IsOutgoing: 0,
                IsMailbox: 0,
                IsGroup: 0,
                IsMissed: 0,
                AnsweredCalls: 0
            });
            _this.topByNumbers = ko.observableArray();
            _this.topByQueues = ko.observableArray();
            _this.topByUsers = ko.observableArray();
            _this.topByNumbersCount = ko.observable(3);
            _this.topByQueuesCount = ko.observable(3);
            _this.topByUsersCount = ko.observable(3);
            _this.activityRangeText = ko.observable("1 Hour");
            _this.autoRefreshText = ko.observable("Auto Refresh - Off");
            _this.filterCdrByExtension = ko.observable("");
            _this.filterApplied = ko.observable(false);
            _this.filterInProgress = ko.observable(false);
            _this.reloadDataTimer = 0;
            _this.autoRefreshDataTimer = 0;
            _this.currentChartRange = ko.observable(0);
            return _this;
        }
        ActivityDashboard.prototype.init = function () {
            var self = this;
            $(window).off("resize.ace_hover");
            tools.ajaxGet({
                url: "/Reports/GetUserDomains",
                success: function (data) {
                    if (data.Success) {
                        self.domainList = data.Data;
                    }
                    else {
                        log.error(data.Error);
                    }
                    ko.applyBindings(self, document.getElementById("ko-main-content"));
                    self.initMain();
                    self.initDashboard();
                    self.initActivityChart();
                    self.initPieChart();
                    if (!self.filterCdrByDomain()) {
                        self.filterCdrByDomain(self.domainList[0]);
                    }
                    $(".loader-container").hide();
                    $("#mainContext").show();
                }
            });
        };
        ActivityDashboard.prototype.initDashboard = function () {
            var self = this;
            self.filterCdrByExtension.extend({ rateLimit: 200 }).subscribe(function () {
                self.filterApplied(false);
                self.applyFilter();
            });
            tools.initMenuActions(".date-ranges li a", self);
            tools.initMenuActions(".refresh-types li a", self);
            $("#chartToggleButtons1 .zoom-chart").on("click", function () {
                var title = $("#chartToggleButtons1 .inner-title").text();
                var chartId = "recentActivityChart";
                setTimeout(function () {
                    self.zoomChart(chartId, "chartContainer1", title, function () {
                        self.resizeChart();
                    });
                });
            });
            $("#chartToggleButtons2 .zoom-chart").on("click", function () {
                var title = $("#chartToggleButtons2 .inner-title").text();
                var chartId = "recentActivityPieChart";
                setTimeout(function () {
                    self.zoomChart(chartId, "chartContainer2", title, function () {
                        self.resizeChart();
                    });
                });
            });
        };
        ActivityDashboard.prototype.initActivityChart = function () {
            var self = this;
            $("#recentActivityChart").kendoStockChart({
                dataSource: {
                    data: [],
                    schema: {
                        model: {
                            fields: {
                                Date: { type: "time" },
                                IsIncoming: { type: "number" },
                                IsOutgoing: { type: "number" },
                                IsGroup: { type: "number" },
                                IsMissed: { type: "number" }
                            }
                        },
                        data: function (response) { return response.Data; },
                        total: "Total",
                        aggregates: "Aggregates",
                        errors: "Errors"
                    },
                    serverPaging: false
                },
                axisDefaults: self.axisDefaults,
                legend: {
                    visible: true,
                    position: "top",
                    labels: {
                        font: "12px Roboto,sans-serif",
                        color: "#777"
                    },
                    /*markers: {
                       type: "circle",
                        width: 12,
                        height: 12
                    }*/
                },
                dataBound: function (e) {
                    setTimeout(function () {
                        self.changeChartRange(self.currentChartRange());
                    }, 300);
                },
                dateField: "Date",
                series: [{
                        type: "line",
                        aggregate: "sum",
                        field: "IsIncoming",
                        categoryField: "Date",
                        style: "smooth",
                        name: "Incoming Calls",
                        color: "#66bb6a",
                        markers: {
                            visible: false
                        }
                    }, {
                        type: "line",
                        aggregate: "sum",
                        field: "IsOutgoing",
                        categoryField: "Date",
                        style: "smooth",
                        name: "Outgoing Calls",
                        color: "#29b6f6",
                        markers: {
                            visible: false
                        }
                    }, {
                        type: "line",
                        aggregate: "sum",
                        field: "IsGroup",
                        categoryField: "Date",
                        style: "smooth",
                        name: "Group Calls",
                        color: "#ffa726",
                        markers: {
                            visible: false
                        }
                    }, {
                        type: "line",
                        aggregate: "sum",
                        field: "IsMissed",
                        categoryField: "Date",
                        style: "smooth",
                        name: "Missed Calls",
                        color: "#ef5350",
                        markers: {
                            visible: false
                        }
                    }
                ],
                categoryAxis: [{
                        baseUnitStep: "auto",
                        baseUnit: "fit",
                        //maxDateGroups: 30,
                        autoBaseUnitSteps: {
                            days: [1, 2, 3],
                            hours: [1, 2, 3],
                            months: [1, 2, 3],
                            weeks: [1, 2],
                            minutes: [15, 30]
                        },
                        /*labels: {
                            rotation: "auto"
                        },*/
                        majorGridLines: {
                            visible: true
                        },
                        majorTicks: {
                            visible: true
                        },
                        crosshair: {
                            visible: true
                        }
                    }],
                valueAxis: [{
                        title: {
                            text: "Total Calls",
                            visible: false
                        },
                        majorGridLines: {
                            visible: true
                        },
                        visible: true,
                        labels: {
                            format: "N0"
                        }
                    }],
                tooltip: {
                    visible: true,
                    shared: true,
                    format: "N0",
                    font: self.axisDefaults.title.font,
                    sharedTemplate: kendo.template($("#chart-tooltip-template").html()),
                },
                /*chartArea: {
                    height: 300
                },*/
                navigator: {
                    pane: {
                        height: 65
                    },
                    hint: {
                        visible: false
                    },
                    series: [{
                            type: "line",
                            aggregate: "sum",
                            field: "IsIncoming",
                            categoryField: "Date",
                            style: "smooth",
                            name: "Incoming Calls",
                            color: "#66bb6a",
                            markers: {
                                visible: false
                            }
                        }, {
                            type: "line",
                            aggregate: "sum",
                            field: "IsOutgoing",
                            categoryField: "Date",
                            style: "smooth",
                            name: "Outgoing Calls",
                            color: "#29b6f6",
                            markers: {
                                visible: false
                            }
                        }, {
                            type: "line",
                            aggregate: "sum",
                            field: "IsGroup",
                            categoryField: "Date",
                            style: "smooth",
                            name: "Group Calls",
                            color: "#ffa726",
                            markers: {
                                visible: false
                            }
                        }, {
                            type: "line",
                            aggregate: "sum",
                            field: "IsMissed",
                            categoryField: "Date",
                            style: "smooth",
                            name: "Missed Calls",
                            color: "#ef5350",
                            markers: {
                                visible: false
                            }
                        }],
                    select: {
                        from: DateUtils.addHours(DateUtils.now(), -1),
                        to: DateUtils.now()
                    },
                    /*categoryAxis: {
                        labels: {
                            rotation: "auto"
                        }
                    }*/
                }
            });
            $(window).on("resize", function () {
                self.resizeChart();
            });
        };
        ActivityDashboard.prototype.initPieChart = function () {
            var self = this;
            $("#recentActivityPieChart").kendoChart({
                axisDefaults: self.axisDefaults,
                legend: {
                    visible: true,
                    position: "right",
                    orientation: "vertical",
                    offsetY: -70,
                    width: 200,
                    labels: {
                        font: self.axisDefaults.title.font,
                        color: self.axisDefaults.title.color,
                        margin: {
                            right: 50
                        }
                    },
                    item: {
                        visual: self.createLegendItem.bind(self)
                    }
                },
                seriesDefaults: {
                    type: "pie",
                    //startAngle: 150,
                    overlay: self.seriesDefaults.overlay,
                    labels: {
                        template: "#= kendo.format('{0:P0}', percentage)#",
                        position: function (e) {
                            if (e.percentage < 0.1)
                                return "outsideEnd";
                            else
                                return "center";
                        },
                        /*color(e) {
                            if (e.percentage < 0.1)
                                return self.axisDefaults.title.color;
                            else
                                return "#fff";
                        },*/
                        visible: true,
                        background: "transparent",
                        font: self.axisDefaults.title.font,
                        visual: function (e) {
                            var value = parseInt(e.text);
                            if (value === 0) {
                                return null;
                            }
                            return e.createVisual();
                        }
                    }
                },
                series: [{
                        name: "Calls",
                        field: "calls",
                        colorField: "color",
                        categoryField: "extension",
                        padding: 30,
                        border: {
                            width: 2,
                            color: "white",
                            dashType: "solid"
                        }
                    }],
                dataSource: {
                    data: []
                },
                valueAxis: [{
                        line: {
                            visible: false
                        },
                        axisCrossingValue: 0
                    }],
                tooltip: {
                    visible: true,
                    font: self.axisDefaults.title.font,
                    color: "white",
                    template: function (e) {
                        var value = kendo.toString(e.value, "N0");
                        return "".concat(e.category, " \u2013 ").concat(value);
                    }
                },
                /*chartArea: {
                    height: 300
                }*/
            }).data("kendoChart");
        };
        ActivityDashboard.prototype.createColumn = function (rect, color) {
            var origin = rect.origin;
            var center = rect.center();
            var radiusX = rect.width() / 2;
            var radiusY = radiusX;
            var topArcGeometry = new geometry.Arc([center.x, origin.y]);
            topArcGeometry.startAngle = 0;
            topArcGeometry.endAngle = 360;
            topArcGeometry.radiusX = radiusX;
            topArcGeometry.radiusY = radiusY;
            var topArc = new drawing.Arc(topArcGeometry, {
                fill: {
                    color: color
                },
                stroke: {
                    color: "#ededed"
                }
            });
            var group = new drawing.Group();
            group.append(topArc);
            return group;
        };
        ActivityDashboard.prototype.createLegendItem = function (e) {
            var self = this;
            var isLast = e.pointIndex + 1 === e.series.data.length;
            var color = e.options.markers.background;
            var labelColor = e.options.labels.color;
            var rect = new geometry.Rect([0, 0], [200, 25]);
            var layout = new drawing.Layout(rect, {
                spacing: 5,
                alignItems: "center"
            });
            var overlay = drawing.Path.fromRect(rect, {
                fill: {
                    color: "#fff",
                    opacity: 0
                },
                stroke: {
                    color: "none"
                },
                cursor: "pointer"
            });
            var column = self.createColumn(new geometry.Rect([0, 0], [15, 10]), color);
            var label = new drawing.Text(e.series.data[e.pointIndex][e.series.categoryField], new kendo.geometry.Point(0, 0), {
                fill: {
                    color: labelColor
                },
                font: self.axisDefaults.title.font
            });
            if (isLast) {
                var totalRect = new geometry.Rect([0, 0], [200, 50]);
                var totalLayout = new drawing.Layout(totalRect, {
                    spacing: 5,
                    alignItems: "center"
                });
                var total = 0;
                for (var i = 0; i < e.series.data.length; i++) {
                    if (e.series.data[i].visible === undefined || e.series.data[i].visible) {
                        total += e.series.data[i][e.series.field];
                    }
                }
                var totalLabel = new drawing.Text("Total: ".concat(kendo.toString(total, "N0")), new kendo.geometry.Point(0, 0), {
                    fill: {
                        color: self.axisDefaults.title.color
                    },
                    font: "bold 14px Roboto,sans-serif"
                });
                totalLayout.append(totalLabel);
                totalLayout.reflow();
                var tr = new geometry.Transformation();
                var totalGroup = new drawing.Group();
                totalGroup.append(totalLayout);
                totalGroup.transform(tr.translate(95, -15));
                totalLayout.transform(tr.translate(0, -10));
                layout.append(column, label, totalGroup);
            }
            else {
                layout.append(column, label);
            }
            layout.reflow();
            var group = new drawing.Group().append(layout);
            return group;
        };
        ActivityDashboard.prototype.changeTopCountClick = function (item, event) {
            var self = this;
            var action = $(event.target).data("actiondata");
            var type = $(event.target).data("type");
            switch (type) {
                case 1:
                    self.topByNumbersCount(action);
                    break;
                case 2:
                    self.topByQueuesCount(action);
                    break;
                case 3:
                    self.topByUsersCount(action);
                    break;
                default:
            }
        };
        ActivityDashboard.prototype.changeChartRangeClick = function (item, event) {
            var self = this;
            var action = $(event.target).data("actiondata");
            self.changeChartRange(action);
        };
        ActivityDashboard.prototype.changeChartRange = function (action) {
            var self = this;
            var chart = $("#recentActivityChart").data("kendoStockChart");
            if (!chart) {
                return;
            }
            var lastDate = DateUtils.now();
            var fromDate = DateUtils.addHours(lastDate, -1);
            var dataItems = chart.dataSource.data();
            var lastItem = dataItems[(dataItems.length - 1)];
            if (lastItem) {
                lastDate = kendo.parseDate(lastItem.Date);
                log.log("last date", lastDate);
            }
            self.currentChartRange(action);
            switch (action) {
                case 0:
                    log.log("action 0", action);
                    self.activityRangeText("1 Hour");
                    fromDate = DateUtils.addHours(lastDate, -1);
                    break;
                case 1:
                    log.log("action 1", action);
                    self.activityRangeText("6 Hour");
                    fromDate = DateUtils.addHours(lastDate, -6);
                    break;
                case 2:
                    log.log("action 2", action);
                    self.activityRangeText("1 Day");
                    fromDate = DateUtils.stripTime(lastDate);
                    break;
                default:
            }
            var navi = chart.navigator;
            if (navi) {
                navi.select( /*fromDate, lastDate*/);
            }
        };
        ActivityDashboard.prototype.resizeChart = function () {
            setTimeout(function () {
                kendo.resize($("#recentActivityChart"), true);
                kendo.resize($("#recentActivityPieChart"), true);
            }, 100);
        };
        ActivityDashboard.prototype.getGrandTotals = function () {
            var self = this;
            var data = {
                domain: self.filterCdrByDomain(),
                fromdate: DateUtils.toIsoStringDate(self.filterCdrSummaryReportByStartDate()),
                todate: DateUtils.toIsoStringDate(self.filterCdrSummaryReportByEndDate())
            };
            tools.ajaxGet({
                url: "/Reports/GetActivityTotals",
                data: data,
                success: function (data) {
                    if (data.Success) {
                        self.grandTotalsData(data.Data.GrandTotals[0] || {
                            IsLocal: 0,
                            IsIncoming: 0,
                            IsOutgoing: 0,
                            IsMailbox: 0,
                            IsGroup: 0,
                            IsMissed: 0,
                            AnsweredCalls: 0
                        });
                        self.topByNumbers(data.Data.TopByNumber);
                        self.topByQueues(data.Data.TopByGroup);
                        self.topByUsers(data.Data.TopByUser);
                        var chart = $("#recentActivityChart").data("kendoStockChart");
                        if (chart) {
                            chart.dataSource.data(data.Data.TimeSeriesTotals);
                        }
                        var pieChart = $("#recentActivityPieChart").data("kendoChart");
                        if (pieChart) {
                            var pieData = [
                                {
                                    calls: self.grandTotalsData().IsIncoming,
                                    color: "#66bb6a",
                                    extension: "Incoming Calls"
                                }, {
                                    calls: self.grandTotalsData().IsOutgoing,
                                    color: "#29b6f6",
                                    extension: "Outgoing Calls"
                                }, {
                                    calls: self.grandTotalsData().IsGroup,
                                    color: "#ffa726",
                                    extension: "Group Calls"
                                }, {
                                    calls: self.grandTotalsData().IsMissed,
                                    color: "#ef5350",
                                    extension: "Missed Calls"
                                }
                            ];
                            pieChart.dataSource.data(pieData);
                        }
                        self.runCountTo();
                    }
                }
            }).always(function () {
                $(".loader-container").hide();
            });
        };
        ActivityDashboard.prototype.refresh = function (seconds) {
            var self = this;
            log.log(seconds);
            if (self.autoRefreshDataTimer > 0) {
                clearTimeout(self.autoRefreshDataTimer);
            }
            if (seconds === 0) { //today
                self.autoRefreshText("Auto Refresh - Off");
            }
            else if (seconds === 10) {
                self.autoRefreshText("Every 10 sec");
            }
            else if (seconds === 20) {
                self.autoRefreshText("Every 20 sec");
            }
            else if (seconds === 30) {
                self.autoRefreshText("Every 30 sec");
            }
            else if (seconds === 60) {
                self.autoRefreshText("Every 1 min");
            }
            else if (seconds === 300) {
                self.autoRefreshText("Every 5 min");
            }
            else if (seconds === 600) {
                self.autoRefreshText("Every 10 min");
            }
            if (seconds > 0) {
                self.setAutoRefresh(seconds);
            }
        };
        ActivityDashboard.prototype.setAutoRefresh = function (seconds) {
            var self = this;
            self.autoRefreshDataTimer = setTimeout(function () {
                self.applyFilter();
                self.setAutoRefresh(seconds);
            }, seconds * 1000);
        };
        ActivityDashboard.prototype.applyFilter = function () {
            _super.prototype.applyFilter.call(this);
            var self = this;
            if (self.reloadDataTimer > 0) {
                clearTimeout(self.reloadDataTimer);
            }
            self.reloadDataTimer = setTimeout(function () {
                $(".loader-container").show();
                self.getGrandTotals();
            }, 300);
        };
        ActivityDashboard.prototype.clearFilter = function () {
            _super.prototype.clearFilter.call(this);
            var self = this;
            self.filterCdrSummaryReportByStartDate(DateUtils.today());
            self.filterCdrSummaryReportByEndDate(DateUtils.today());
            self.filterCdrByDomain(self.domainList[0]);
            self.filterCdrByExtension("");
            self.multipleCallTypeSelector.value(["Incoming", "Outgoing"]);
            self.multipleCallTypeSelector.trigger("change");
            self.multipleStatusSelector.value([]);
            self.multipleStatusSelector.trigger("change");
        };
        ActivityDashboard.prototype.exportTo = function () {
            var self = this;
            if (self.canExport()) {
                self.mainTable.exportTo();
            }
        };
        return ActivityDashboard;
    }(ReportBase));
    setTimeout(function () {
        if (urls_1.urls.startsWith("/Reports/ActivityDashboard")) {
            log.log("Initialize ActivityDashboard list");
            $(function () {
                (new ActivityDashboard()).init();
            });
        }
    }, 0);
    return ActivityDashboard;
});
//# sourceMappingURL=ActivityDashboard.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/reports/activityDashboard.js
// module id = 248
// module chunks = 2